import { render } from "./Table2.vue?vue&type=template&id=044a3d87&scoped=true&ts=true"
import script from "./Table2.vue?vue&type=script&lang=ts"
export * from "./Table2.vue?vue&type=script&lang=ts"

import "./Table2.vue?vue&type=style&index=0&id=044a3d87&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044a3d87"]])

export default __exports__